// extracted by mini-css-extract-plugin
export var alertIcon = "_w0-0";